<template>
  <el-dialog v-dialogDrag width="600px" title="删除权限" :visible.sync="delPermissionVisible" :close-on-click-modal="false" @close="delPermissionDialogClose">
    <div class="delPermissionBox">
      <div class="titleError"><i class="el-icon-warning" /> 确认删除选中的权限资源吗？注意子级权限也会被同时删除</div>
      <div class="title">警告:删除权限码可能会带来严重的后果</div>
      <el-checkbox v-model="realDelete" class="checkbox" :true-label="1" :false-label="0">彻底删除（数据无法恢复）</el-checkbox>
      <div v-show="realDelete" class="password">
        <span>请输入运维密码：</span>
        <el-input v-model="password" type="password" autocomplete="new-password" size="small" style="width: 210px"></el-input>
      </div>
    </div>
    <template #footer>
      <el-button size="small" @click="delPermissionVisible = false"> 取消 </el-button>
      <el-button type="primary" size="small" @click="submitDelPermission"> 确定 </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      password: "",
      realDelete: 0,
      delPermissionVisible: false
    };
  },
  watch: {
    realDelete: {
      handler(newVal) {
        if (newVal === 0) {
          this.password = "";
        }
      }
    }
  },
  methods: {
    delPermissionDialogClose() {
      this.delPermissionVisible = false;
    },
    openDelDlg() {
      this.delPermissionVisible = true;
      this.password = "";
      this.realDelete = 0;
    },
    deleteModuleHandler() {
      this.delPermissionVisible = true;
      this.password = "";
    },
    submitDelPermission() {
      this.$emit("submitDelPermission", this.realDelete, this.password);
    }
  }
};
</script>
